import React, { useState, useEffect } from 'react';
import { playThemeSound } from '../../../utils/themeAudio';

const HEART_ICONS = ['❤️', '💖', '💘', '💕', '🌹', '💌', '✨'];
const POP_FORTUNES = ['YOU’RE AMAZING! 💖', 'SWEET LOVE! 🌹', 'CRITICAL HIT! 💘', 'PURE CHARM! ✨', 'SOULMATE! 💌'];

const InteractiveHearts = () => {
    const [hearts, setHearts] = useState([]);
    const [popEffects, setPopEffects] = useState([]);
    const [cupidHits, setCupidHits] = useState([]);
    const [potionBubbles, setPotionBubbles] = useState(false);

    useEffect(() => {
        const initial = Array.from({ length: 24 }).map((_, i) => ({
            id: i,
            icon: HEART_ICONS[Math.floor(Math.random() * HEART_ICONS.length)],
            left: Math.random() * 95,
            delay: Math.random() * 5,
            duration: 7 + Math.random() * 7,
            size: 16 + Math.random() * 18,
            opacity: 0.5 + Math.random() * 0.45,
            popped: false
        }));
        setHearts(initial);
    }, []);

    // Global click listener: shoot Cupid's Arrow towards click location
    useEffect(() => {
        const handleGlobalClick = (e) => {
            const tagName = e.target.tagName.toLowerCase();
            if (['input', 'textarea', 'button', 'a', 'select'].includes(tagName)) return;
            if (e.target.closest('button') || e.target.closest('a') || e.target.closest('input')) return;

            playThemeSound('valentines', 'arrow');

            const hitId = Date.now() + Math.random();
            setCupidHits(prev => [...prev, {
                id: hitId,
                x: e.clientX,
                y: e.clientY
            }]);

            setTimeout(() => {
                setCupidHits(prev => prev.filter(item => item.id !== hitId));
            }, 900);
        };

        window.addEventListener('click', handleGlobalClick, { passive: true });
        return () => window.removeEventListener('click', handleGlobalClick);
    }, []);

    const handleHeartClick = (h, e) => {
        e.stopPropagation();
        playThemeSound('valentines', 'pop');

        const rect = e.currentTarget.getBoundingClientRect();
        const effectId = Date.now() + Math.random();
        const text = POP_FORTUNES[Math.floor(Math.random() * POP_FORTUNES.length)];

        setPopEffects(prev => [...prev, {
            id: effectId,
            x: rect.left,
            y: rect.top,
            text
        }]);

        setTimeout(() => {
            setPopEffects(prev => prev.filter(item => item.id !== effectId));
        }, 1100);

        setHearts(prev => prev.map(item => {
            if (item.id === h.id) return { ...item, popped: true };
            return item;
        }));

        setTimeout(() => {
            setHearts(prev => prev.map(item => {
                if (item.id === h.id) {
                    return {
                        ...item,
                        popped: false,
                        left: Math.random() * 95,
                        delay: 0,
                        duration: 7 + Math.random() * 7
                    };
                }
                return item;
            }));
        }, 2800);
    };

    const brewLovePotion = () => {
        playThemeSound('valentines', 'loveChime');
        setPotionBubbles(true);
        setTimeout(() => setPotionBubbles(false), 2400);

        // Pop up sweet blessing
        const effectId = Date.now();
        setPopEffects(prev => [...prev, {
            id: effectId,
            x: window.innerWidth - 180,
            y: window.innerHeight - 120,
            text: '💖 LOVE POTION BREWED! +100 CHARM!'
        }]);

        setTimeout(() => {
            setPopEffects(prev => prev.filter(item => item.id !== effectId));
        }, 1800);
    };

    return (
        <div className="fixed inset-0 pointer-events-none z-[61] overflow-hidden select-none">
            {/* Cupid Arrow Click Hits */}
            {cupidHits.map((hit) => (
                <div
                    key={hit.id}
                    className="fixed -translate-x-1/2 -translate-y-1/2 z-[70] pointer-events-none animate-ping text-xl"
                    style={{ left: hit.x, top: hit.y }}
                >
                    🏹 💖
                </div>
            ))}

            {/* Click/Pop Fortune Floating text */}
            {popEffects.map((eff) => (
                <div
                    key={eff.id}
                    className="fixed text-xs md:text-sm font-extrabold text-rose-300 drop-shadow-[0_2px_8px_rgba(244,63,94,0.9)] animate-float-up pointer-events-none z-[75]"
                    style={{ left: eff.x, top: eff.y }}
                >
                    {eff.text}
                </div>
            ))}

            {/* Interactive Love Potion Bottle on Bottom-Right */}
            <div className="fixed bottom-5 right-4 md:right-8 z-[68] pointer-events-auto">
                <button
                    type="button"
                    onClick={brewLovePotion}
                    className="px-3 py-1.5 rounded-2xl bg-gray-950/85 hover:bg-gray-900 border border-rose-500/50 text-rose-300 text-xs font-bold shadow-lg shadow-black/50 transition-all hover:scale-110 active:scale-95 flex items-center gap-1.5 group"
                    title="Click to brew Cupid's Love Potion!"
                >
                    <span className="text-lg group-hover:animate-bounce">🧪</span>
                    <span className="hidden sm:inline">Brew Love Potion</span>
                    {potionBubbles && <span className="animate-ping">✨</span>}
                </button>
            </div>

            {/* Floating Hearts */}
            {hearts.map((h) => {
                if (h.popped) return null;
                return (
                    <div
                        key={h.id}
                        onClick={(e) => handleHeartClick(h, e)}
                        onTouchStart={(e) => handleHeartClick(h, e)}
                        className="absolute bottom-[-60px] animate-float-up pointer-events-auto cursor-pointer hover:scale-140 transition-transform"
                        style={{
                            left: `${h.left}%`,
                            fontSize: `${h.size}px`,
                            opacity: h.opacity,
                            animationDelay: `${h.delay}s`,
                            animationDuration: `${h.duration}s`,
                            filter: 'drop-shadow(0 0 8px rgba(244, 63, 94, 0.6))',
                        }}
                        title="Click to pop love hearts!"
                    >
                        {h.icon}
                    </div>
                );
            })}

            {/* Bottom Rose Mist */}
            <div className="fixed bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-rose-950/30 via-pink-900/10 to-transparent pointer-events-none z-[25]" />
        </div>
    );
};

export default InteractiveHearts;
